import { BaseApi } from '@/main/baseApi';

class AboutProvider extends BaseApi {
	constructor() {
		super('', '');
	}

	getAboutAplicationData() {
		return this.fetch('/About');
	}
}

export const apiProvider = new AboutProvider();
